import { Controller } from 'react-hook-form';
import { InputText, InputSize } from '@ui/src';
import RiskFormWrapper from '../../partial/risk-form-wrapper';
import RiskFormItem from '../../partial/risk-form-item';
import FormBlock from '../../geogrpahical/form-block';
import { RiskScoreCalculationType } from '../../../hoc/types';
import { VolumesRiskTransactionsFormTypes } from './types';

import cn from './form.module.css';

const VolumesRiskTransactionsForm = ({
  control,
  individualClientCalculate,
  corporateClientCalculate,
  onSubmit,
  requestInProgress,
  isEditable,
  corporateErrorVisible,
  individualErrorVisible,
}: VolumesRiskTransactionsFormTypes) => (
  <RiskFormWrapper
    onSubmit={onSubmit}
    requestInProgress={requestInProgress}
    disabled={!isEditable}
  >
    <>
      <RiskFormItem title="Factors for individual clients">
        <FormBlock
          control={control}
          radioName="individualClientCalculate"
          calculateBy={individualClientCalculate}
          minimumRiskScore
          disabled={!isEditable}
          volumeRiskBlock
        >
          <>
            <div className={cn.formBlockInputWrapper}>
              <Controller
                control={control}
                name="individualSingleTranscationVol"
                defaultValue=""
                render={({ field: { onChange, value } }) => (
                  <InputText
                    name="individualSingleTranscationVol"
                    placeholder=""
                    onChange={onChange}
                    value={value}
                    size={InputSize.SMALL}
                    title="Single transaction vol."
                    disabled={
                      individualClientCalculate !==
                      RiskScoreCalculationType.WEIGHT
                    }
                    labelClassName={cn.formBlockLabel}
                  />
                )}
              />
            </div>
            <div className={cn.formBlockInputWrapper}>
              <Controller
                control={control}
                name="individualMultipleTranscationVol"
                defaultValue=""
                render={({ field: { onChange, value } }) => (
                  <InputText
                    name="individualMultipleTranscationVol"
                    placeholder=""
                    onChange={onChange}
                    value={value}
                    size={InputSize.SMALL}
                    title="Multiple transactions vol."
                    disabled={
                      individualClientCalculate !==
                      RiskScoreCalculationType.WEIGHT
                    }
                    labelClassName={cn.formBlockLabel}
                  />
                )}
              />
            </div>
            {individualErrorVisible && (
              <div className={cn.errorMessage}>
                Single transaction vol. and Multiple transactions vol. sum must
                be equal 1
              </div>
            )}
          </>
        </FormBlock>
      </RiskFormItem>
      <RiskFormItem title="Factors for corporate clients">
        <FormBlock
          control={control}
          radioName="corporateClientCalculate"
          calculateBy={corporateClientCalculate}
          disabled={!isEditable}
          minimumRiskScore
          volumeRiskBlock
        >
          <>
            <div className={cn.formBlockInputWrapper}>
              <Controller
                control={control}
                name="corporateSingleTranscationVol"
                defaultValue=""
                render={({ field: { onChange, value } }) => (
                  <InputText
                    name="corporateSingleTranscationVol"
                    placeholder=""
                    title="Single transaction vol."
                    onChange={onChange}
                    size={InputSize.SMALL}
                    value={value}
                    disabled={
                      corporateClientCalculate !==
                      RiskScoreCalculationType.WEIGHT
                    }
                  />
                )}
              />
            </div>
            <div className={cn.formBlockInputWrapper}>
              <Controller
                control={control}
                name="corporateMultipleTranscationVol"
                defaultValue=""
                render={({ field: { onChange, value } }) => (
                  <InputText
                    name="corporateMultipleTranscationVol"
                    title="Multiple transactions vol."
                    placeholder=""
                    onChange={onChange}
                    size={InputSize.SMALL}
                    value={value}
                    disabled={
                      corporateClientCalculate !==
                      RiskScoreCalculationType.WEIGHT
                    }
                  />
                )}
              />
            </div>
            {corporateErrorVisible && (
              <div className={cn.errorMessage}>
                Single transaction vol. and Multiple transactions vol. sum must
                be equal 1
              </div>
            )}
          </>
        </FormBlock>
      </RiskFormItem>
    </>
  </RiskFormWrapper>
);

export default VolumesRiskTransactionsForm;
